import React, { useState } from 'react';
import PropTypes from 'prop-types';
import GoogleMapReact from 'google-map-react';
import { Query, ApolloProvider } from 'react-apollo';
import { useInView } from 'react-intersection-observer';
import { nearbyRentalsQuery } from '../constants/queries';
import { client } from './client';
import RentalMarker from './Map/RentalMarker';

export default function NearbyRentals({ center }) {
  const [activeMarker, setActiveMarker] = useState(null);
  const [bounds, setBounds] = useState({});

  const { sw, ne } = bounds;

  const [ref, inView] = useInView({
    threshold: 0,
    triggerOnce: true,
  });

  return (
    <div ref={ref} className="page-nearby-rentals">
      {inView && (
        <ApolloProvider client={client}>
          <Query
            query={nearbyRentalsQuery}
            variables={
              bounds.sw
                ? {
                    polygon: `[${sw.lng.toFixed(6)},${sw.lat.toFixed(
                      6
                    )},${ne.lng.toFixed(6)},${ne.lat.toFixed(6)}]`,
                  }
                : {}
            }
          >
            {({ data, error }) => {
              if (error) console.error(error);

              return (
                <div className="page-nearby-rentals-map">
                  <GoogleMapReact
                    bootstrapURLKeys={{
                      // @TODO: Add this to an environment variable or something
                      key: 'AIzaSyATvnQePj9OTTCZJ6VkugYM8dRGFPJ5HmQ',
                    }}
                    defaultCenter={center}
                    defaultZoom={12}
                    onChange={({ bounds: newBounds }) => setBounds(newBounds)}
                  >
                    {data &&
                      data.properties &&
                      data.properties.collection.map(property => (
                        <RentalMarker
                          key={property.id}
                          lat={property.latitude}
                          lng={property.longitude}
                          property={property}
                          activeMarker={activeMarker}
                          changeActiveMarker={setActiveMarker}
                        />
                      ))}
                  </GoogleMapReact>
                </div>
              );
            }}
          </Query>
        </ApolloProvider>
      )}
    </div>
  );
}

NearbyRentals.propTypes = {
  center: PropTypes.object.isRequired,
};
